var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnshipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77148 0.162109C6.89148 0.162109 5.15148 0.82211 3.77148 1.92211C1.93148 3.38211 0.771484 5.64211 0.771484 8.16211C0.771484 9.66211 1.19148 11.0821 1.93148 12.2821C3.31148 14.6021 5.85148 16.1621 8.77148 16.1621C10.7915 16.1621 12.6315 15.4221 14.0315 14.1621C14.6515 13.6421 15.1915 13.0021 15.6115 12.2821C16.3515 11.0821 16.7715 9.66211 16.7715 8.16211C16.7715 3.74211 13.1915 0.162109 8.77148 0.162109ZM5.61148 7.08211C5.03148 6.50211 5.03148 5.54211 5.61148 4.96211C6.21148 4.38211 7.15148 4.38211 7.75148 4.96211L8.79148 6.02211L9.79148 5.00211C10.3915 4.42211 11.3315 4.42211 11.9315 5.00211C12.5115 5.60211 12.5115 6.54211 11.9315 7.14211L10.9115 8.14211L11.9715 9.18211C12.5515 9.78211 12.5515 10.7221 11.9715 11.3221C11.6715 11.6021 11.2915 11.7421 10.9115 11.7421C10.5315 11.7421 10.1515 11.6021 9.85148 11.3221L8.79148 10.2621L7.69148 11.3621C7.39148 11.6621 7.01148 11.8021 6.63148 11.8021C6.25148 11.8021 5.87148 11.6621 5.57148 11.3621C4.99148 10.7821 4.99148 9.82211 5.57148 9.24211L6.67148 8.14211L5.61148 7.08211Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnshipped);
export default __webpack_public_path__ + "static/media/unshipped.631cff2b9d5e5879ca6591e5c2c03f08.svg";
export { ForwardRef as ReactComponent };